<template>
  <div>
    <a-cascader
      :value="selectedValue"
      :options="options"
      :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
      @change="handleChange"
      placeholder="请选择经营组及对接人"
      style="width: 100%"
    />
  </div>
</template>

<script>
import { fetchTopList } from "@/api/setting/area";

export default {
  name: "BusinessContactSelector",
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      areaList: [], // 区域列表
      options: [], // 级联选择器选项
    };
  },
  computed: {
    selectedValue() {
      if (this.value.businessGroupId && this.value.businessContactUserId) {
        return [this.value.businessGroupId, this.value.businessContactUserId];
      }
      return [];
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        const res = await fetchTopList();
        this.areaList = res || [];
        this.buildOptions();
      } catch (error) {
        console.error("加载经营组数据失败:", error);
      }
    },

    // 构建级联选择器选项
    buildOptions() {
      this.options = this.areaList.map((area) => {
        const children = [];
        
        // 从 userMap 中提取用户列表
        if (area.userMap) {
          Object.keys(area.userMap).forEach((userId) => {
            children.push({
              id: userId,
              name: area.userMap[userId],
            });
          });
        }

        return {
          id: area.id,
          name: area.areaName,
          children: children,
        };
      });
    },

    // 处理选择变化
    handleChange(value) {
      if (value && value.length === 2) {
        const [groupId, userId] = value;
        
        // 查找经营组名称
        const area = this.areaList.find((item) => item.id === groupId);
        const groupName = area ? area.areaName : "";
        
        // 查找用户名称
        const userName = area && area.userMap ? area.userMap[userId] : "";

        this.$emit("change", {
          businessGroupId: groupId,
          businessGroup: groupName,
          businessContactUserId: userId,
          businessContactUserName: userName,
        });
      } else {
        this.$emit("change", {
          businessGroupId: null,
          businessGroup: null,
          businessContactUserId: null,
          businessContactUserName: null,
        });
      }
    },
  },
};
</script>
